/* GY Mega Menu — hover intent with delay */
(function() {
  var nav = document.querySelector('.gy-nav');
  if (!nav) return;

  var links = nav.querySelectorAll('.gy-nav__link[data-mega]');
  var panel = document.getElementById('gy-mega-menu');
  if (!panel || links.length === 0) return;

  var showTimeout, hideTimeout;
  var SHOW_DELAY = 150;
  var HIDE_DELAY = 300;

  function show() {
    clearTimeout(hideTimeout);
    showTimeout = setTimeout(function() {
      panel.classList.add('is-open');
    }, SHOW_DELAY);
  }

  function hide() {
    clearTimeout(showTimeout);
    hideTimeout = setTimeout(function() {
      panel.classList.remove('is-open');
    }, HIDE_DELAY);
  }

  links.forEach(function(link) {
    link.addEventListener('mouseenter', show);
    link.addEventListener('mouseleave', hide);
  });

  panel.addEventListener('mouseenter', function() {
    clearTimeout(hideTimeout);
  });
  panel.addEventListener('mouseleave', hide);

  // Keyboard: Escape closes
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      panel.classList.remove('is-open');
    }
  });
})();
